// CommitteeSubscriptionItem.tsx
// Created: 01/27/2025
// Purpose: React component for individual committee subscription toggle

import React from 'react';
import Moment from 'moment';
import * as dateFormatter from '../../dateFormatter';

export interface ICommittee {
    committeeId: number;
    name: string;
    acronym: string;
    entityType: string;
    url: string;
    isSubscribed: boolean;
    subscribedDate: string | null;
    hideFromAllCommitteeList: boolean;
}

interface ICommitteeSubscriptionItemProps {
    committee: ICommittee;
    index: number;
    onToggle: (committee: ICommittee) => void;
}

interface State { }

export default class CommitteeSubscriptionItem extends React.Component<ICommitteeSubscriptionItemProps, State> {
    constructor(props: ICommitteeSubscriptionItemProps) {
        super(props);
        this.state = {};
    }

    public handleToggle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.onToggle(this.props.committee);
    }

    public formatDate(date: string | null): string {
        if (!date) return '';
        var tempDate = Moment.utc(date, Moment.ISO_8601, true);
        return dateFormatter.DateFormatter.Format(tempDate, "MM/DD/YYYY");
    }

    public render() {
        const { committee } = this.props;
        const checkboxId = `committee-${committee.committeeId}`;

        return (
            <div className="col-12 col-md-6 d-inline-grid">
                <div className="panel panel-default committee-panel margin-top-5 margin-btm-10 d-inline-grid" style={{ borderRadius: '4px', border: '1px solid #c2c2c3' }}>
                    <div className="panel-heading h-100 padding-15" role="tab">
                        <div className="d-flex align-items-start">
                            <div className="form-check form-switch margin-right-15">
                                <input
                                    type="checkbox"
                                    id={checkboxId}
                                    className="form-check-input"
                                    checked={committee.isSubscribed}
                                    onChange={e => this.handleToggle(e)}
                                />
                            </div>
                            <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <a href={committee.url} target="_blank" rel="noopener noreferrer" className="committee-link">
                                            <h4 className="margin-btm-0 black bold d-inline">{committee.name}</h4>
                                        </a>
                                        {committee.isSubscribed && committee.subscribedDate && (
                                            <span style={{fontStyle:"italic"}}><span className="text-muted small margin-left-10">Subscribed: {this.formatDate(committee.subscribedDate)}</span></span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    {committee.acronym && (
                                        <span className="badge bg-secondary margin-right-5">{committee.acronym}</span>
                                    )}
                                    {committee.entityType && (
                                        <span className="text-muted small">{committee.entityType}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
